import axios from "axios";
import { UserViewModel } from "../viewModels";
 
const getCurrentUser = (): UserViewModel | null => {
  const userJson = localStorage.getItem("auth") || sessionStorage.getItem("auth");
  if (userJson) {
    return JSON.parse(userJson) as UserViewModel;
  }
  return null;
};

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
   withCredentials: true
});

apiClient.interceptors.request.use(
  (config) => {
    const user = getCurrentUser();
    if (user?.token) {
      // Ensure headers object exists
      config.headers = config.headers ?? {};
      //config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
export interface  IError {
  description: string;
  code: string;
}
export default apiClient;